<script>
export default {
  name: "UserView",
  data() {
    return {
      queryData: {
        pageNo: 1,
        pageSize: 10,
        username: '',
      },
      total: 0,
      dataList: [],
      disabled: true,
      selectChange: [],
      selectChangeId: [],
      title: '',
      DialogVisible: false,
      formData: {
        id: '',
        username: '',
        password: '',
        roleName: '',
        roleDescribes: '',
        remarks: ''
      },
      formRules: {},
      roleDialogVisible: false,
      options: [],
      value: '',
      userId: ''
    }
  },
  created() {
    this.list()
    // this.getAllRole()
  },
  methods: {
    list() {
      const _this = this
      this.$axios.post('user/list', this.queryData).then(function (res) {
        _this.dataList = res.data.data.records
        _this.total = res.data.data.total
      }).catch(function (err) {
        _this.$Message.error(err)
      })
    },
    handleSizeChange(pageSize) {
      this.queryData.pageSize = pageSize
      this.list()
    },
    handleCurrentChange(pageNo) {
      this.queryData.pageNo = pageNo
      this.list()
    },
    getAllRole() {
      const _this = this
      this.$axios.post('role/all/list', null).then(function (res) {
        if (res.data.code === 200) {
          _this.options = res.data.data
        } else {
          _this.$message({
            type: 'error',
            message: res.data.msg
          })
        }
      }).catch(function (err) {
        _this.$Message.error(err)
      })
    },
    handleSearch() {
      this.list()
    },
    clear() {
      this.list()
    },
    handleAdd: function () {
      this.title = '添加用户'
      this.DialogVisible = true
    },
    handleEdit(id) {
      this.title = '编辑用户'
      this.DialogVisible = true
      const _this = this
      const data = {
        id: id
      }
      this.$axios.post('user/detail', data).then(function (res) {
        _this.formData = res.data.data
      }).catch(function (err) {
        _this.$Message.error(err)
      })
    },
    handleDelete(id) {
      const _this = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.delete(id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    delete(id) {
      const _this = this
      const data = {
        id: id
      }
      this.$axios.post('user/delete', data).then(function (res) {
        if (res.data.code === 200) {
          _this.$message({
            type: 'success',
            message: res.data.msg
          })
          _this.list()
        } else {
          _this.$message({
            type: 'error',
            message: res.data.msg
          })
        }
      }).catch(function (err) {
        _this.$Message.error(err)
      })
    },
    changeSelect(val) {
      this.selectChange = val
      this.lengths = this.selectChange.length
      this.disabled = this.lengths === 0
    },
    getIds() {
      for (let i = 0; i < this.selectChange.length; i++) {
        this.selectChangeId.push(this.selectChange[i].id)
      }
    },
    // 批量删除按钮
    handleDeletes() {
      const _this = this
      this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.deleteAll()
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        })
        _this.selectChangeId = []
      })
    },
    deleteAll() {
      this.getIds()
      const _this = this
      this.loading = true
      this.$axios.post('user/deletes', this.selectChangeId).then(function (res) {
        _this.$message({
          type: 'success',
          message: res.data.msg
        })
        _this.list()
      }).catch(function (err) {
        _this.$Message.error(err)
      })
    },
    handleSave() {
      const _this = this
      this.$axios.post('user/save', this.formData).then(function (res) {
        _this.$refs.formRef.resetFields()
        _this.formData.id = ''
        _this.$message({
          type: 'success',
          message: res.data.msg
        })
        _this.DialogVisible = false
        _this.list()
      }).catch(function (err) {
        _this.$Message.error(err)
      })
    },
    handleCancel() {
      this.$refs.formRef.resetFields()
      this.DialogVisible = false
      Object.keys(this.formData).forEach(key => this.formData[key] = '');
    },
    closeDialog() {
      Object.keys(this.formData).forEach(key => this.formData[key] = '');
      this.$refs.formRef.resetFields()
      this.DialogVisible = false
    },
    handleAuthorizeRole(id) {
      this.roleDialogVisible = true
      this.getRole(id)
    },
    getRole(id) {
      this.userId = id
      const _this = this
      const data = {
        userId: _this.userId
      }
      this.$axios.post('role/info/by/userId', data).then(function (res) {
        if (res.data.code === 200) {
          _this.value = res.data.data.id
        } else {
          _this.$message({
            type: 'error',
            message: res.data.msg
          })
        }
      }).catch(function (err) {
        _this.$Message.error(err)
      })
    },
    handleBindRole() {
      const _this = this
      const data = {
        id: '',
        userId: _this.userId,
        roleId: _this.value
      }
      this.$axios.post('user/bind/role', data).then(function (res) {
        if (res.data.code === 200) {
          _this.$message({
            type: 'success',
            message: res.data.msg
          })
          _this.value = ''
          _this.roleDialogVisible = false
          _this.list()
        } else {
          _this.$message({
            type: 'error',
            message: res.data.msg
          })
        }
      }).catch(function (err) {
        _this.$Message.error(err)
      })
    },
    handleCancelBindRole() {
      this.value = ''
      this.roleDialogVisible = false
    },
    closeRoleDialogVisible() {
      this.value = ''
      this.roleDialogVisible = false
    }
  }
}
</script>

<template>
  <div>
    <!--    <el-row style="margin-top:20px ">-->
    <!--      <el-col :span="3">-->
    <!--        <el-input placeholder="账号" v-model="queryData.username" clearable @clear="clear"></el-input>-->
    <!--      </el-col>-->
    <!--      <el-col :span="3" style="margin-left: 20px">-->
    <!--        <el-input placeholder="手机" v-model="queryData.mobile" clearable @clear="clear"></el-input>-->
    <!--      </el-col>-->
    <!--      <el-col :span="3" style="margin-left: 20px">-->
    <!--        <el-button type="primary" @click="handleSearch">搜索</el-button>-->
    <!--      </el-col>-->
    <!--    </el-row>-->
    <el-row style="text-align: left;margin-top: 20px">
      <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleAdd">新增</el-button>
      <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDeletes" :disabled="disabled">删除
      </el-button>
    </el-row>
    <el-table :data="dataList" style="width: 100%;margin-top: 20px" border @selection-change="changeSelect">
      <el-table-column type="selection" width="50" align="center">
      </el-table-column>
      <el-table-column label="账号" prop="username" align="center"></el-table-column>
<!--      <el-table-column label="角色名称" prop="roleName" align="center"></el-table-column>-->
<!--      <el-table-column label="角色标识" prop="roleDescribes" align="center"></el-table-column>-->
      <el-table-column label="备注" prop="remarks" align="center"></el-table-column>
      <el-table-column label="创建时间" prop="createTime" align="center"></el-table-column>
      <el-table-column label="更新时间" prop="updateTime" align="center"></el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="scope">
          <!--          <el-button size="mini" type="text" @click="handleEdit(scope.row.id)">编辑</el-button>-->
          <el-button size="mini" type="text" @click="handleDelete(scope.row.id)">删除</el-button>
<!--          <el-button size="mini" type="text" @click="handleAuthorizeRole(scope.row.id)">分配角色</el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <div class="block" style="margin-top: 20px">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryData.pageNo"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="queryData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>
    <el-dialog :title="title" :visible.sync="DialogVisible" width="50%" center @close='closeDialog'>
      <el-form :model="formData" :rules="formRules" ref="formRef" label-width="50px">
        <el-form-item label="账号" prop="username">
          <el-input v-model="formData.username"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="formData.password" type="password"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input v-model="formData.remarks"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="handleCancel">取 消</el-button>
    <el-button type="primary" @click="handleSave">确 定</el-button>
  </span>
    </el-dialog>

    <el-dialog title="分配角色" :visible.sync="roleDialogVisible" width="20%" center @close='closeRoleDialogVisible'>
      <el-select v-model="value" placeholder="请选择">
        <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.id">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
    <el-button @click="handleCancelBindRole">取 消</el-button>
    <el-button type="primary" @click="handleBindRole">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<style scoped>

</style>